import React, { useEffect, useState } from 'react';
import MenuLinks from './MenuLinks';

function Footer() {
    const [time, setTime] = useState(new Date());
    
    useEffect(() => {
        const interval = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(interval);
    }, []);
    
    const year = time.getFullYear();

    return (
        <footer className="bg-[#04347c] shadow md:m-4">
            <div className="w-full max-w-screen-xl p-4 mx-auto md:py-8">
                <div className="sm:flex sm:items-center sm:justify-between">
                    <a href="#" className="flex items-center mb-4 space-x-3 sm:mb-0 rtl:space-x-reverse">
                        <img src="/logo.png" className="h-16" alt="Logo" />
                        <span className="self-center text-3xl font-semibold text-white whitespace-nowrap">Tisson Lanka</span>
                    </a>
                    <ul className="flex items-center mb-6 text-lg font-medium text-white sm:flex-wrap">
                        <li>
                            <a href="/" className="hover:underline me-4 md:me-6">Home</a>
                        </li>
                        <li>
                            <a href="/About" className="hover:underline me-4 md:me-6">About</a>
                        </li>
                        <li>
                            <a href="/Items" className="hover:underline me-4 md:me-6">Our Production</a>
                        </li>
                        <li>
                            <a href="/Itemsimport" className="hover:underline me-4 md:me-6">Imported Products</a>
                        </li>
                        <li>
                            <a href="/Contact" className="hover:underline">Contact</a>
                        </li>
                    </ul>
                </div>
                <hr className="mx-auto my-6 border-gray-200 lg:my-8" />
                <span className="block text-sm text-center text-white">© {year} <a href="/" className="hover:underline">Tisson Lanka (PVT) LTD</a>. All Rights Reserved.</span>
            </div>
        </footer>
    );
}

export default Footer;
